(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gyaan-blog')) {
    class GyaanBlog extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('[data-filter]');
          if (chip && this.contains(chip)) this.apply(chip.dataset.filter);
        });
      }

      apply(filter) {
        const limit = parseInt(this.dataset.limit, 10) || 4;
        let shown = 0;

        this.querySelectorAll('[data-filter]').forEach((chip) => {
          const active = chip.dataset.filter === filter;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        this.querySelectorAll('.gm-card[data-tags]').forEach((card) => {
          const tags = card.dataset.tags.split('|');
          const match = filter === 'all' || tags.includes(filter);
          const visible = match && shown < limit;
          card.hidden = !visible;
          if (visible) shown += 1;
        });
      }
    }

    customElements.define('gyaan-blog', GyaanBlog);
  }

  } catch(e) { console.error(e); }
})();
})();
